import { GraphQLError } from "graphql";
import _ from "lodash";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getErrorMessage(error: any): string {
  if (!error) {
    return "";
  } else if (_.isArray(error)) {
    return error.map(getErrorMessage).join(", ");
  } else if (error.message && _.isString(error.message)) {
    return error.message;
  } else {
    return error.toString();
  }
}

export function graphqlErrorHasCode(
  code: string,
  errors: readonly GraphQLError[]
): boolean {
  return errors.some(error => error.extensions?.code === code);
}
